import { useState } from "react";
import { useTranslation } from "next-i18next";
import Numeral from "numeral";
import Text from "ab-text";
import CTA from "ab-cta";
import Premios from "ab-premios";
import InfoAdditional from "ab-info-additional";
import ParagraphText from "ab-paragraph-text";
import Personalizacion from "ab-personalizacion";
import { useCartContext } from "ab-context-cart";
import { parseWCPriceToFloat } from "ab-functions";

import "./ab-pdp.scss";

const PDP = ({
  name,
  description,
  productos_ingles,
  productos_aleman,
  attributes,
  products,
  price,
  type,
  databaseId,
  stockQuantity,
  stockStatus,
  image,
  groupedProductIngles,
  groupedProductAleman,
  productCategories,
  galleryImages,
  language,
  metaData,
  personalizacion,
  etiquetaSKU,
  i18n,
}) => {
  // console.log("PDP - etiquetaSKU - ", productCategories);
  // console.log("PDP - galleryImages Product - ", galleryImages);
  // console.log("PDP - productos_ingles - ", language, groupedProductIngles);
  const [selectedProduct, setSelectedProduct] = useState();
  const [stockError, setStockError] = useState(false);
  const [numBotellas, setNumBotellas] = useState(1);
  const [state, dispatch] = useCartContext();
  const { addItemToCart } = dispatch;
  const [selectedAnada, selectAnada] = useState();

  const { t } = useTranslation("common", { i18n });
  const esProductoFinca = () => {
    return productCategories?.nodes?.find((itm) =>
      i18n.language == "en"
        ? "Products from the Estate"
        : i18n.language == "de"
        ? "Produkte vom Weingut"
        : "Productos de la Finca"
    );
  };

  // boolean para mostrar o no personalizacion

  const nuestrosVinos = () => {
    return productCategories?.nodes?.find((itm) => {
      const category = "Vinos con Denominación de Origen Protegida";
      return category === itm.name;
    });
  };

  const esNuestrosVinos = nuestrosVinos();

  const seleccionNavidad = () => {
    return productCategories?.nodes?.find((itm) => {
      const category = "Un vino para los tuyos a un precio especial";
      return category === itm.name;
    });
  };
  console.log("PDP - productCategories - ", productCategories);

  // TODO añadir +1 por cada botella añadida --> count
  let customiceLabelPrice = personalizacion?.price || 5;
  let etiquetaPrice = etiquetaSKU?.price || 1;
  console.log(
    "parseFloat(customiceLabelPrice)",
    parseWCPriceToFloat(customiceLabelPrice) +
      numBotellas * parseWCPriceToFloat(etiquetaPrice)
  );

  const [personalizeEtiqueta, setPersonalizeEtiqueta] = useState(false);
  const [etiquetaText, setEtiquetaText] = useState("");

  // console.log("#### PDP - groupedProductIngles - ", groupedProductIngles);
  // console.log("#### PDP - description - ", description);

  let _description =
    i18n.language == "en"
      ? productos_ingles?.contentIngles ||
        groupedProductIngles?.description ||
        description
      : i18n.language == "de"
      ? productos_aleman?.contentAleman ||
        groupedProductAleman?.descriptionAleman ||
        description
      : description;

  _description = esProductoFinca() ? description : _description;

  const notasDeCata =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "notas_de_cata")?.value
      : selectedProduct?.productos?.notasDeCata;
  const notasDeCataIngles =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "notas_de_cata_ingles")?.value
      : selectedProduct?.productos_ingles?.notasDeCataIngles;
  const notasDeCataAleman =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "notas_de_cata_aleman")?.value
      : selectedProduct?.productos_aleman?.notasDeCataAleman;

  const notasAnada =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "notas_anada")?.value
      : selectedProduct?.productos?.notasAnada;
  const notasAnadaIngles =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "notas_anada_ingles")?.value
      : selectedProduct?.productos_ingles?.notasAnadaIngles;
  const notasAnadaAleman =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "notas_anada_aleman")?.value
      : selectedProduct?.productos_aleman?.notasAnadaAleman;

  const premios =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "premios")?.value
      : selectedProduct?.productos?.premios;
  const premiosIngles =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "premios_ingles")?.value
      : selectedProduct?.productos_ingles?.premiosIngles;
  const premiosAleman =
    type === "SIMPLE"
      ? metaData?.find((itm) => itm.key == "premios_aleman")?.value
      : selectedProduct?.productos_aleman?.premiosAleman;

  const infoAddicional =
    type === "SIMPLE"
      ? {
          variedad: metaData?.find(
            (itm) => itm.key == "info_addicional_variedad"
          )?.value,
          conservacion: metaData?.find(
            (itm) => itm.key == "info_addicional_conservacion"
          )?.value,
          denominacionDeOrigen: metaData?.find(
            (itm) => itm.key == "info_addicional_denominacion_de_origen"
          )?.value,
          vida: metaData?.find((itm) => itm.key == "info_addicional_vida")
            ?.value,
          alergenos: metaData?.find(
            (itm) => itm.key == "info_addicional_alergenos"
          )?.value,
          gradoAlcoholico: metaData?.find(
            (itm) => itm.key == "info_addicional_grado_alcoholico"
          )?.value,
          informacionNutricional: metaData?.find(
            (itm) => itm.key == "info_addicional_informacion_nutricional"
          )?.value,
          elaboradoYEmbotelladoPor: metaData?.find(
            (itm) => itm.key == "info_addicional_elaborado_y_embotellado_por"
          )?.value,
          ingredientes: metaData?.find(
            (itm) => itm.key == "info_addicional_ingredientes"
          )?.value,
        }
      : selectedProduct?.productos?.infoAddicional;

  const infoAddicionalIngles =
    type === "SIMPLE"
      ? {
          variedad: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_variedad"
          )?.value,
          conservacion: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_conservacion"
          )?.value,
          denominacionDeOrigen: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_denominacion_de_origen"
          )?.value,
          vida: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_vida"
          )?.value,
          alergenos: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_alergenos"
          )?.value,
          gradoAlcoholico: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_grado_alcoholico"
          )?.value,
          informacionNutricional: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_informacion_nutricional"
          )?.value,
          elaboradoYEmbotelladoPor: metaData?.find(
            (itm) =>
              itm.key == "info_addicional_ingles_elaborado_y_embotellado_por"
          )?.value,
          ingredientes: metaData?.find(
            (itm) => itm.key == "info_addicional_ingles_ingredientes"
          )?.value,
        }
      : selectedProduct?.productos_ingles?.infoAddicionalIngles;

  const infoAddicionalAleman =
    type === "SIMPLE"
      ? {
          variedad: metaData?.find(
            (itm) => itm.key == "info_addicional_aleman_variedad"
          )?.value,
          conservacion: metaData?.find(
            (itm) => itm.key == "info_addicional_aleman_conservacion"
          )?.value,
          denominacionDeOrigen: metaData?.find(
            (itm) => itm.key == "info_addicional_aleman_denominacion_de_origen"
          )?.value,
          vida: metaData?.find(
            (itm) => itm.key == "info_addicional_aleman_vida"
          )?.value,
          alergenos: metaData?.find(
            (itm) => itm.key == "info_addicional_aleman_alergenos"
          )?.value,
          gradoAlcoholico: metaData?.find(
            (itm) => itm.key == "info_addicional_grado_aleman_alcoholico"
          )?.value,
          informacionNutricional: metaData?.find(
            (itm) => itm.key == "info_addicional_aleman_informacion_nutricional"
          )?.value,
          elaboradoYEmbotelladoPor: metaData?.find(
            (itm) =>
              itm.key == "info_addicional_aleman_elaborado_y_embotellado_por"
          )?.value,
          ingredientes: metaData?.find(
            (itm) => itm.key == "info_addicional_aleman_ingredientes"
          )?.value,
        }
      : selectedProduct?.productos_aleman?.infoAddicionalAleman;

  const handleAddToCart = async (product, count: number, authToken) => {
    let addons = [];

    if (personalizeEtiqueta && etiquetaText) {
      addons.push({
        name: "Servicio de personalizacion",
        price: "0",
        value: "Si",
      });
      addons.push({
        name: "Texto para la etiqueta",
        price: parseWCPriceToFloat(etiquetaPrice)?.toFixed(2) || "1",
        value: etiquetaText,
      });
      addons.push({
        name: "Nuestros vinos",
        price: "",
        value: product.name,
      });
    }

    let extraData = {
      addons,
    };
    await addItemToCart(
      { ...product },
      count,
      authToken,
      JSON.stringify(extraData)
    );
    if (personalizeEtiqueta && etiquetaText) {
      await addItemToCart(personalizacion, 1, authToken, null);
    }
    return true;
  };

  const isValidForCustomize = () => {
    let res=false;
    let anadaSelected = parseInt(selectedAnada);
    let anadas = [];
    if (!attributes) {
      products?.nodes?.map((itm) => {
        anadas = itm?.attributes?.nodes?.find((itm) => itm.name == "Añada");
      });
    } else {
      anadas = attributes?.nodes?.find((itm) => itm.name == "Añada");
    }
    const  anadasArray = anadas?.options ?? [];
    const sortedArray = [...anadasArray];
    sortedArray.sort(function(a, b) {
        return parseInt(a) - parseInt(b);
    });
    const selectedFromato= selectedProduct?.attributes.nodes.find(atr=> atr.name==="Formato")?.options[0]
   
    if(selectedFromato==='0.75L'){
      res= sortedArray[sortedArray.length-1]<=anadaSelected
    }else if(selectedFromato==='1.5L'){
      //Especial case for 1.5L we let customize the Añada before the last one:
      // [2000, 2001, 2002] then for 1.5L 2001 is valid to customize
       res= sortedArray[sortedArray.length-2]<=anadaSelected
    }
    return res;
   
  };
  console.log("#### PDP - attributes - ", attributes);
  return (
    <div className="ab-pdp">
      <div className="image">
        <Text element="h2">{name}</Text>
        <img
          src={
            selectedProduct?.image?.mediaItemUrl ||
            galleryImages?.nodes?.[0]?.mediaItemUrl ||
            image?.mediaItemUrl
          }
          alt={name}
        />
      </div>

      <div className="detail">
        <h1>{`${esProductoFinca() ? "" : t("vino")} ${name}`}</h1>
        <Text element="h2">{name}</Text>
        <div
          className={`cta${stockError ? " stock-error" : ""}${
            esNuestrosVinos ? " personalice-margin" : ""
          }`}
        >
          <CTA
            type="anadir"
            text={t("anadir")}
            plus={true}
            price={price}
            attributes={attributes?.nodes}
            products={products?.nodes}
            setSelectedProduct={setSelectedProduct}
            selectedProduct={
              type === "SIMPLE"
                ? {
                    name,
                    price,
                    attributes,
                    type,
                    databaseId,
                    stockQuantity,
                    stockStatus,
                  }
                : selectedProduct
            }
            productType={type}
            i18n={i18n}
            setStockError={setStockError}
            stockError={stockError}
            esNuestrosVinos={esNuestrosVinos}
            setNumBotellas={setNumBotellas}
            callbackAddToCart={handleAddToCart}
            seleccionNavidad={seleccionNavidad()}
            selectAnada={selectAnada}
          />
        </div>
        {stockError ? (
          <div className="stock-error-text">{t("no-hay-stock")}</div>
        ) : null}

        {isValidForCustomize() && esNuestrosVinos  ? (
          <Personalizacion
            personalizeEtiqueta={personalizeEtiqueta}
            setPersonalizeEtiqueta={setPersonalizeEtiqueta}
            etiquetaText={etiquetaText}
            setEtiquetaText={setEtiquetaText}
            customiceLabelPrice={`(+${Numeral(
              parseWCPriceToFloat(customiceLabelPrice) +
                numBotellas * parseWCPriceToFloat(etiquetaPrice)
            ).format("1,000.00$")})`}
            serviceSKU={personalizacion}
            etiquetaSKU={etiquetaSKU}
            i18n={i18n}
          />
        ) : null}

        <div className="row">
          <ParagraphText content={_description} />
        </div>

        {selectedProduct || type === "SIMPLE" ? (
          <>
            {selectedProduct?.imagenDescripcion?.mediaItemUrl ? (
              <img src={selectedProduct?.imagenDescripcion?.mediaItemUrl} />
            ) : null}

            {/* PREMIOS ESPAÑOL */}
            {i18n.language == "es" && premios ? (
              <Premios wine premios={premios} i18n={i18n} />
            ) : null}
            {/* PREMIOS INGLES */}
            {i18n.language == "en" && premiosIngles ? (
              <Premios wine premios={premiosIngles} i18n={i18n} />
            ) : null}
            {/* PREMIOS ALEMAN */}
            {i18n.language == "de" && premiosAleman ? (
              <Premios wine premios={premiosAleman} i18n={i18n} />
            ) : null}

            {/* NOTAS DE CATA INGLES */}
            {i18n.language == "en" && notasDeCataIngles ? (
              <>
                <Text element="h2" className="mobile" style={{ marginTop: 92 }}>
                  {t("notas-de-cata")}
                </Text>
                <div className="row">
                  <ParagraphText content={notasDeCataIngles} />
                </div>
                {selectedProduct?.imagenCata?.mediaItemUrl ? (
                  <img src={selectedProduct?.imagenCata?.mediaItemUrl} />
                ) : null}
              </>
            ) : null}
            {/* NOTAS DE CATA ALEMAN */}
            {i18n.language == "de" &&
            (notasDeCataAleman || notasDeCataIngles) ? (
              <>
                <Text element="h2" className="mobile" style={{ marginTop: 92 }}>
                  {t("notas-de-cata")}
                </Text>
                <div className="row">
                  <ParagraphText
                    content={notasDeCataAleman || notasDeCataIngles}
                  />
                </div>
                {selectedProduct?.imagenCata?.mediaItemUrl ? (
                  <img src={selectedProduct?.imagenCata?.mediaItemUrl} />
                ) : null}
              </>
            ) : null}

            {/* NOTAS DE CATA ESPAÑOL */}
            {i18n.language == "es" && notasDeCata ? (
              <>
                <Text element="h2" className="mobile" style={{ marginTop: 92 }}>
                  {t("notas-de-cata")}
                </Text>
                <div className="row">
                  <ParagraphText content={notasDeCata} />
                </div>
                {selectedProduct?.imagenCata?.mediaItemUrl ? (
                  <img src={selectedProduct?.imagenCata?.mediaItemUrl} />
                ) : null}
              </>
            ) : null}

            {/* NOTAS DE AÑADA INGLES */}

            {i18n.language == "en" && notasAnadaIngles ? (
              <>
                <Text element="h2" className="mobile" style={{ marginTop: 92 }}>
                  {`${selectedProduct?.attributes?.nodes?.find(
                    (itm) => itm.name == "Añada"
                  )?.options?.[0] || ""} Vintage`}
                </Text>
                <div className="row">
                  <ParagraphText content={notasAnadaIngles} />
                </div>
                {selectedProduct?.imagenAnada?.mediaItemUrl ? (
                  <img src={selectedProduct?.imagenAnada?.mediaItemUrl} />
                ) : null}
              </>
            ) : null}

            {/* NOTAS DE AÑADA ALEMAN */}

            {i18n.language == "de" && (notasAnadaAleman || notasAnadaIngles) ? (
              <>
                <Text element="h2" className="mobile" style={{ marginTop: 92 }}>
                  {`Jahrgang ${selectedProduct?.attributes?.nodes?.find(
                    (itm) => itm.name == "Añada"
                  )?.options?.[0] || ""} `}
                </Text>
                <div className="row">
                  <ParagraphText
                    content={notasAnadaAleman || notasAnadaIngles}
                  />
                </div>
                {selectedProduct?.imagenAnada?.mediaItemUrl ? (
                  <img src={selectedProduct?.imagenAnada?.mediaItemUrl} />
                ) : null}
              </>
            ) : null}

            {/* NOTAS DE AÑADA ESPAÑOL */}
            {i18n.language == "es" && notasAnada ? (
              <>
                <Text element="h2" className="mobile" style={{ marginTop: 92 }}>
                  {`Añada ${selectedProduct?.attributes?.nodes?.find(
                    (itm) => itm.name == "Añada"
                  )?.options?.[0] || ""}`}
                </Text>
                <div className="row">
                  <ParagraphText content={notasAnada} />
                </div>
                {selectedProduct?.imagenAnada?.mediaItemUrl ? (
                  <img src={selectedProduct?.imagenAnada?.mediaItemUrl} />
                ) : null}
              </>
            ) : null}

            {/* INFO ADICIONAL */}

            {i18n.language == "en" ? (
              <InfoAdditional {...infoAddicionalIngles} i18n={i18n} />
            ) : i18n.language == "de" ? (
              <InfoAdditional {...infoAddicionalAleman} i18n={i18n} />
            ) : (
              <InfoAdditional {...infoAddicional} i18n={i18n} />
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default PDP;
